import React from "react";
import About from './about.jsx';
import BackToTop from './back-top.jsx';
import Contact from './contact.jsx';
import Intro from './intro.jsx';
import Navbar from './navbar.jsx';
import Portfolio from './portfolio.jsx';
import Preloader from './preloader';

class Home extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Navbar />
                <Intro />
                <About />
                <Portfolio />
                <Contact />
                <BackToTop />
                <Preloader />
            </React.Fragment>
        );
    }
}

export default Home;